import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from "react-router";

import ReactMarkdown from 'react-markdown'
import "./MarkdownView.css"

import { makeStyles } from '@material-ui/styles';
import { Theme, createStyles, Paper } from '@material-ui/core';

import config from '../../config'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.background.default,
      marginTop: theme.spacing(8),
      marginLeft: "auto",
      marginRight: "auto",
      padding: theme.spacing(2),
      maxWidth:  800,
      width: "60%"
    },
  }),
);

type TParams = { 
  topic?: string 
  type: string;
};

const MarkdownView: React.FC<RouteComponentProps<TParams>> = (props: RouteComponentProps<TParams>) => {

    const [content, setContent] = useState('');
    const classes = useStyles();
    const { params } = props.match

    useEffect(() => {

        switch (params.type) {
          case "help":
            break;
          default:
            if (!params.topic) {
              params.type= "help"
              params.topic= params.type;
            } else {
              console.error("Unsupported document type" + params.type);
              params.type= "help";
            }
        }          

        let url = `${config.meet.hosts.web}/${params.type}`;
        if (params.topic) {
          url += `/${params.topic}`
        }

        fetch(url, {
          mode: "cors",
          headers: {
            "meet-i18n": localStorage.getItem("meet-i18n") || "en"
          }
        })
            .then(res => {
              const t = res.text();
              return t;
            })
            .then(text => {
              setContent(text)
            });
    }, [params]);

    return (
        <Paper className={classes.root}>
          <ReactMarkdown source={content} className="md-markdown"/>
        </Paper>
    );
}

export default MarkdownView;
